import {TransportCardInfoNew} from '../../../models/api/transportCardInfoNew';

export default {
  number: '222002040',
  cardName: 'Проездной для граждан',
  tariffName: 'Городской на 10 дней',
  balanceInRubles: 0,
  validTo: 'Действительна по: 03.10.2020',
  unwrittenPayment: 'Поступил платёж: 200 руб. Для записи пополнения на карту совершите поездку',
} as TransportCardInfoNew;
